function setLocalStorage(key, value) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    // Remove item
    window.localStorage.removeItem(key);
    // Set item
    window.localStorage.setItem(key, value);
  } catch (error) {
    // If error also return initialValue
    console.log(error);
  }
}
export default setLocalStorage;
